import globalSlice from "./slices/globalSlice";
import userSlice from "./slices/userSlice";
import eventSlice from "./slices/eventSlice";
import chapterSlice from "./slices/chapterSlice";
import roleSlice from "./slices/roleSlice";
import venueSlice from "./slices/venueSlice";
import questionSlice from "./slices/QuestionSlice";
import categorySlice from "./slices/CategorySlice";
import subscriptionSlice from "./slices/subscriptionSlice";
import auditLogSlice from "./slices/auditLogSlice";
import supportSlice from "./slices/supportSlice";
import paymentSlice from "./slices/paymentSlice";
import ticketPaymentSlice from "./slices/ticketPaymentSlice";
import commentReportSlice from "./slices/commentReportSlice";
import dashboardSlice from "./slices/dashboardSlice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  global: globalSlice,
  dashboard: dashboardSlice,
  user: userSlice,
  event: eventSlice,
  chapter: chapterSlice,
  role: roleSlice,
  venue: venueSlice,
  question: questionSlice,
  category: categorySlice,
  subscription: subscriptionSlice,
  auditLog: auditLogSlice,
  support: supportSlice,
  payment: paymentSlice,
  ticketPayment: ticketPaymentSlice,
  commentReport: commentReportSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
